import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function Translate(oProps) {
    const { t: fTranslate } = useTranslation();
    const { label: sKey, options: oOptions = null } = oProps;
    return fTranslate(sKey, oOptions)
}

Translate.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.exact({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), max_length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), name: PropTypes.string }),
};

export default Translate;